
import { Drawer } from "element-ui"
import { getStockMax } from "../../utils/utils"
import inputNumber from "./components/inputNumber.vue"
import { handleChangeCartNumber } from "@/utils/track"
import { handleAddToCartV2, handleModifyCartV2 } from "@/utils/cartResponse"
import customContent from "@/components/customContent.vue"

export default {
  name: "ProductCustomSku",
  components: {
    [Drawer.name]: Drawer,
    inputNumber,
    customContent
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    configs: {
      type: Object,
      default: () => {},
      required: true
    },
    isCartPage: {
      type: Boolean,
      default: false
    },
    customContentConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      curValue: 1, // 当前商品数量
      curCount: 1, // 当前变化的商品数量
      curVisible: false,
      customValue: "defaultOption",
      customText: ""
    }
  },

  watch: {
    visible: {
      immediate: true, // 添加 immediate 确保初始化时执行
      handler(val) {
        this.curVisible = val
        if (val) {
          this.resetCustomConfig()
        }
      }
    }
  },
  created() {
    if (!process.client) {
      return
    }
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
  },
  mounted() {},
  methods: {
    getStockMax,
    handleChangeCartNumber,
    resetCustomConfig() {
      this.$nextTick(() => {
        this.$refs?.customContent?.reset()
      })
    },
    updateCustomValue(value) {
      this.customValue = value
    },
    updateCustomText(value) {
      this.customText = value
    },
    async handleSave() {
      if (!this.curCount || (this.customContentConfig && this.customValue === "customOption" && !this.customText)) {
        return
      }

      handleChangeCartNumber(this.curCount, this.configs.addCartCount || 0, this.configs)
      const { venderId, storeId, sku } = this.configs.additional
      try {
        if (this.isCartPage) {
          this.$emit("updateCustomContent", { customValue: this.customValue, customText: this.customText })
        } else {
          const [error, data] = await handleAddToCartV2({
            venderId,
            storeId: storeId || this.commonReqParams.storeId,
            wares: [{ sku, count: this.curCount, checked: 1 }],
            sort: 1,
            otherParams: this.customContentConfig
              ? {
                  customisationList: [
                    {
                      count: this.curCount,
                      checked: 1,
                      remarkReq: this.customValue === "defaultOption" ? "Default" : this.customText,
                      remarkType: this.customValue
                    }
                  ]
                }
              : {}
          })
          if (data) {
            this.curValue = 1
            this.$emit("close", "save")
          }
          if (error && error.code === "WEB_1203") {
            // 强制更新：先重置，再赋新值
            this.curValue = 0 // 触发响应式更新
            this.$nextTick(() => {
              this.curValue = error?.data // 确保下次赋值被检测到
            })
          }
        }
      } catch (error) {}
    },
    handleChange(count) {
      this.curCount = count
    },
    handleClose() {
      this.$emit("close")
    }
  }
}
